import styled from 'styled-components'

/** Wrapper do controle lateral quando o modal NÃO está em tela cheia. */
export const ControleLateral = styled.div`
  width: 345px;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  gap: 10px;
  padding-right: 6px;
`

/** Grade de pontos selecionáveis do controle lateral. */
export const ContainerPontosAnalise = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-radius: 8px;

  .points-title {
    color: #757575;
    font-size: 12px;
    font-weight: 700;
    margin: 0;
    padding: 0;
  }

  .points-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
  }

  .point-card {
    background-color: var(--cor-do-item);
    color: white;
    border: 2px solid var(--cor-do-item);
    font-weight: 700;
    font-size: 12px;
    width: 30px !important;
    height: 30px;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 10px;
  }

  .point-card:hover {
    transition: 0.5s;
    transform: scale(1.05);
    background-color: var(--cor-do-item);
    border: 2px solid var(--cor-do-item);
    color: white;
  }

  .point-card:is([data-active='true']) {
    background-color: var(--cor-do-item);
    border-color: var(--cor-do-item);
    color: white;
  }

  .add-button {
    background-color: transparent;
    border: 2px solid #6abf8e;
    color: #6abf8e;
    cursor: pointer;
    width: 35px;
    height: 35px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s;
  }

  .add-button:hover {
    background-color: #f0fdf4;
  }

  .infos__pontos__selecionados {
    width: 100%;
    border: 2px solid #d9d9d9;
    padding: 7px;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    div {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      label {
        color: #757575;
        font-size: 12px;
        font-weight: 500;
        margin: 0;
        padding: 0;
      }

      strong {
        font-size: 12px;
        margin: 0;
        padding: 0;
      }
    }
  }
`
